<template>
  <div class="announcement">
    <div>
      <van-nav-bar
        @click-left="onClickLeft"
        fixed
        placeholder
        :title="$t('nav.notice')"
      >
        <template #left>
          <van-icon color="#000" name="arrow-left" />
        </template>
      </van-nav-bar>
    </div>

    <div @click="noticeDetial(1,item.noticeId)" v-for="(item,index) in noticeTitle" :key="index" class="content-section" style="margin-top: 15px">
      <van-row>
        <van-col span="2">
          <van-icon name="arrow-up" />
          <van-icon name="arrow" />
          <van-icon name="arrow-down" />
        </van-col>
        <van-col style="text-align: left;" span="22">
          <div style="color: #747272;padding: 2px;">{{ item.createTime }}</div>
          <div class="item-section">
            {{ item.noticeTitle }}
          </div>
        </van-col>
      </van-row>
    </div>

    <!-- <div @click="noticeDetial(1,2)" class="content-section" style="margin-top: 15px">
      <van-row>
        <van-col span="2">
          <van-icon name="arrow-up" />
          <van-icon name="arrow" />
          <van-icon name="arrow-down" />
        </van-col>
        <van-col style="text-align: left;" span="22">
          <div style="color: #747272;padding: 2px;">2020-03-18 04:22:13</div>
          <div class="item-section">
            Platform announcement
          </div>
        </van-col>
      </van-row>
    </div> -->
    
  </div>
</template>

<script>
import { getNoticeTitle } from "@/common/api/api"

export default {
  name: "announcement",
  data() {
    return {
      url: '/',
      id: 0,
      noticeTitle: []
    };
  },
  created() {
    const id = this.$route.params && this.$route.params.id;
    this.url = id == 2 ? "/account": "/"
    this.id = id;
    this.getNotice();
  },
  methods: {
    onClickLeft() {
      this.$router.push(this.url);
    },
    noticeDetial(val,val1) {
      this.$router.push("/detail/"+val+"/"+this.id+"/"+val1)
    },
    getNotice() {
      getNoticeTitle().then(res => {
        this.noticeTitle = res.data;
      })
    }
  },
};
</script>

<style>
.content-section {
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 10px;
  margin: 0 10px 10px 10px;
}

.item-section {
  border-radius: 4px;
  padding: 10px;
  background-color: #fdfbfb;
}
</style>
